import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=b3b3d89c&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style0 from "../styles/Content.css?vue&type=style&index=0&id=b3b3d89c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b3d89c",
  null
  
)

export default component.exports